import React from 'react';

interface ThemeIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const ThemeIcon: React.FC<ThemeIconProps> = ({ className, ...props }) => (
  <span role="img" aria-label="theme" className={`anticon trebble-theme-icon ${className || ''}`}>
    <svg 
      width="1em" 
      height="1em" 
      viewBox="0 0 50 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <path d="M0 39.064A10.931 10.931 0 0 0 10.939 50H43.75A6.25 6.25 0 0 0 50 43.75v-9.375a6.25 6.25 0 0 0 -6.25 -6.25h-6.064l4.95 -4.95a6.25 6.25 0 0 0 0 -8.839l-6.961 -6.983a6.25 6.25 0 0 0 -8.839 0L21.875 12.314V6.25A6.25 6.25 0 0 0 15.625 0H6.25A6.25 6.25 0 0 0 0 6.25zm43.75 6.25H20.5l12.5 -12.5h10.75c0.861 0 1.564 0.703 1.564 1.561v9.375c0 0.861 -0.706 1.564 -1.564 1.564m-4.425 -25.461 -17.45 17.461V18.936l8.272 -8.272a1.569 1.569 0 0 1 2.206 0l6.972 6.972a1.567 1.567 0 0 1 0 2.208zm-28.389 25.461a6.25 6.25 0 0 1 -6.25 -6.25v-9.378h12.5v9.378a6.25 6.25 0 0 1 -6.25 6.25M4.689 25V17.189h12.5V25zm0 -12.5V6.25c0 -0.861 0.706 -1.561 1.564 -1.561h9.375c0.861 0 1.564 0.703 1.564 1.561V12.5zm6.25 28.906a2.344 2.344 0 1 0 0 -4.686 2.344 2.344 0 0 0 0 4.686" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h50v50H0z"/>
        </clipPath>
      </defs>
    </svg>
  </span>
); 